import { InjectionToken } from '@angular/core';
import { ICodePickerService } from './code.picker.service.interface';


export const CODE_PICKER_SERVICE = new InjectionToken<ICodePickerService>('');